import script from "./abilityPage.vue?vue&type=script&setup=true&lang=js"
export * from "./abilityPage.vue?vue&type=script&setup=true&lang=js"

import "./abilityPage.vue?vue&type=style&index=0&id=09e5e530&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09e5e530"]])

export default __exports__